import { render, staticRenderFns } from "./ShareGroupModal.vue?vue&type=template&id=03d6ae23&scoped=true"
import script from "./ShareGroupModal.vue?vue&type=script&lang=js"
export * from "./ShareGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d6ae23",
  null
  
)

export default component.exports